import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import VueSession from 'vue-session'
import VueCookie from 'vue-cookie'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(ElementUI, { locale })
Vue.use(VueSession)
Vue.use(VueCookie)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
